import { Component } from 'react';
import PropTypes from 'prop-types';

import withStorage from '../withStorage';
import { UNITO_APP_URL } from '../../consts';
import { reportException } from '../../util/logger';

// The `url` arg is attacker-controllable (the /console route runs standalone and
// reads it from the URL hash), so it must never reach location.replace unvalidated:
// a `javascript:` URI would execute in-origin on our *.unito.io host. Every legitimate
// destination is built from UNITO_APP_URL, so we pin the redirect to that exact origin.
function getAllowedRedirectUrl(rawUrl) {
  if (typeof rawUrl !== 'string' || !UNITO_APP_URL) {
    return null;
  }

  try {
    const dest = new URL(rawUrl);

    if (dest.origin === new URL(UNITO_APP_URL).origin) {
      return dest.href;
    }
  } catch (err) {
    // Not a parseable absolute URL (e.g. javascript:, relative, malformed) — refuse below.
  }

  return null;
}

export class RedirectToComponent extends Component {
  static propTypes = {
    t: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { t } = this.props;
    const requestedUrl = t.arg('url');
    const safeUrl = getAllowedRedirectUrl(requestedUrl);

    if (!safeUrl) {
      reportException(new Error('RedirectTo: blocked non-allowlisted redirect URL'), { requestedUrl });
      return;
    }

    window.location.replace(safeUrl);
  }

  render() {
    return null;
  }
}

export const RedirectTo = withStorage(RedirectToComponent);
